import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DraftPost from '../../components/DraftPost';
import DraftPostModal from '../../components/DraftPostModal';
import PlusLogo from '../../../../Assets/Images/plus-square.png';
import { deleteSinglePostAction, getAllPostAction, updatePostAction } from '../../../../module/action/Post';
import { useDispatch, useSelector } from 'react-redux';

function Draft() {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const draftPost = useSelector(e => e.Post.draftPost);
  const [editData, setEditData] = useState(false);
  const showModal = a => {
    setIsModalOpen(true);
    setEditData(a);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    dispatch(getAllPostAction('draft'));
  }, []);

  const updateStatus = (data, status, setPublishLoader) => {
    let obj = {
      ...data,
      status: status,
      categories: data.categories.map(c => c._id),
      book: data.book.length ? data.book[0]._id : null,
      volume: data.volume.length ? data.volume[0]._id : null,
    };
    delete obj.hadith_date_post;
    dispatch(
      updatePostAction(
        obj,
        obj._id,
        false,
        'draft',
        handleOk,
        setPublishLoader,
        obj.book,
        obj.volume,
        obj.categories,

        false,
        false,
        false
      )
    );
  };

  const deletePost = (id, setDeleteLoader) => {
    dispatch(deleteSinglePostAction(id, 'draft', handleOk, setDeleteLoader));
  };

  return (
    <div className="Draft my-12 px-8 innerDashboard">
      {/* <Logo /> */}
      <div className="header  justify-between flex">
        <div className="flex align-middle items-center">
          <h2 className="text-[32px] font-extrabold">Drafts</h2>
        </div>
        <Link to="/new-post">
          <button className="text-base flex justify-center items-center bg-gray-100  h-[48px] w-[218px]  rounded-xl   font-[Poppins-Bold]">
            <img src={PlusLogo} className="mr-2" />
            New Post
          </button>
        </Link>
      </div>
      <div className="postLists py-6 flex flex-wrap justify-between">
        {draftPost &&
          draftPost.map((a, i) => {
            return (
              <DraftPost
                showModal={showModal}
                data={a}
                index={i}
                statusFunction={updateStatus}
                deleteFunction={deletePost}
              />
            );
          })}
      </div>
      <DraftPostModal
        isModalOpen={isModalOpen}
        handleOk={handleOk}
        handleCancel={handleCancel}
        data={editData}
        statusFunction={updateStatus}
        deleteFunction={deletePost}
        status={'draft'}
        actionButtons={true}
      />
    </div>
  );
}

export default Draft;
